<div class="form-group">
    <label>"Add" button position:</label>
    <select class="form-control"
            name="addAnotherPosition"
            [(ngModel)]="fieldOptions.addAnotherPosition"
            (ngModelChange)="dataChangedEvent($event)"
            class="form-control">
    <option value=""></option>
    <option value="both">Both</option>
    <option value="bottom">Bottom</option>
    <option value="top">Hide</option>
  </select>

</div>